import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const Table = ({
  pagination,
  setPagination,
  totalCount,
  columnsArr,
  data,
}) => {
  const columns = useMemo(() => columnsArr, []);

  const table = useMaterialReactTable({
    columns,
    data,
    manualPagination: true,
    rowCount: totalCount,
    onPaginationChange: setPagination,
    state: { pagination },
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableTopToolbar:false
  });

  return <MaterialReactTable table={table} />;
};

export default Table;
